import { render, staticRenderFns } from "./videoiframe.vue?vue&type=template&id=3030917a&"
import script from "./videoiframe.vue?vue&type=script&lang=js&"
export * from "./videoiframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3030917a')) {
      api.createRecord('3030917a', component.options)
    } else {
      api.reload('3030917a', component.options)
    }
    module.hot.accept("./videoiframe.vue?vue&type=template&id=3030917a&", function () {
      api.rerender('3030917a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2E9x1B5henl52/JS/videoiframe.vue"
export default component.exports